<template>
  <section id="admin-filter">
    <h4>Country filter</h4>
    <div class="form-group">
      <label for="country-code" class="form-label">Code</label>
      <input type="text" class="form-control" id="country-code" v-model="entity.code"/>
    </div>
    <div class="form-group">
      <label for="country-name" class="form-label">Name</label>
      <input type="text" class="form-control" id="country-name" v-model="entity.name"/>
    </div>
    <div class="text-center">
      <div class="btn btn-primary sq"  @click="emitSearch">
        Search
      </div>
      <div class="btn btn-danger sq"  @click="close">
        Cancel
      </div>
    </div>
  </section>
</template>
<script>
  import FilterMixin from '../../mixins/FilterMixin'
  export default {
    name: 'CountryFilter',
    mixins: [ FilterMixin ],
    data () {
      return {
        entity: {
          code: '',
          name: ''
        }
      }
    },
    computed: {
      worldAreas () {
        return this.$store.getters['systemOption/options'].filter(({optionType}) => {
          return optionType !== null && optionType.hasOwnProperty('code') && optionType.code === 'WORLD_AREA'
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/Country/CountryFilter.vue